/**
 * Interface for the ParamScripts rule. This must be in sync with the backend: "db.php"
 */
interface IParamScriptsRule {
    id: string;
    productId: string;
    typeDescriptor: any;
    tab: string;
    panel: string;
    title: string;
    sortIndex: number;
    targetPath: string | null;
    targetType: string | null;
    parameterName: string;
    parameterType: string | null;
    parameterProperty: string;
    composite: number;
    parameterValue: any; // TODO: Type this properly
    shopId: number | null;
    customerId: number | null;
    cartId: number | null;
}

export default IParamScriptsRule;
